// prettier-ignore
export const empty = {
  colors: ["#f5f5f5", "#c6c6c6", "#969696", "#737373"],
imageData:[
  [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,],
  [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,],
  [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,
  ],
  [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,
  ],
  [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,
  ],
  [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,
  ],
  [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,
  ],
  [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,
  ],
  [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,
  ],
  [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,
  ],
  [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,
  ],
  [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ],
  [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ],
  [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ],
  [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ],
]}
